import { TypographyV2 } from '@which/seatbelt'

import type { Category } from '../Configs/categories'
import { pageContent } from '../Configs/pageContent'
import type { Products } from './components/RecommendationResults'
import { RecommendationResults } from './components/RecommendationResults'
import styles from './ResultsScreen.module.scss'

interface ResultsScreenProps {
  categorySlug: Category
  products: Products
}

export const ResultsScreen = ({ categorySlug, products }: ResultsScreenProps) => {
  const { content = [] } = pageContent[categorySlug]?.recommendations ?? {}

  return (
    <div className={styles.resultsScreen}>
      {content.map((paragraph, index) => (
        <TypographyV2
          key={index}
          className={styles.paragraph}
          tag="p"
          textStyle="sb-text-interface-body-default-regular"
        >
          {paragraph}
        </TypographyV2>
      ))}

      <RecommendationResults products={products} purchaseJourneyCategory={categorySlug} />
    </div>
  )
}
